import type { TodayResponses } from './todayData';

/**
 * Today → "3 new form responses today" (Prototype v14): a link per form,
 * named for what it collects ("Newsletter · 2 sign-ups", "Contact · 1
 * message"), and whether any were emailed. Responses are read in the app, so
 * a tip or a sign-up is never left unseen.
 */
export function responsesStrip(list: TodayResponses[], period: 'today' | 'this week') {
  if (!list.length) return null;
  const total = list.reduce((n, r) => n + r.count, 0);
  const links = list.map((r) => {
    const word = r.purpose === 'signup' ? 'sign-up' : 'message';
    return {
      key: r.formId,
      label: `${r.name} · ${r.count} ${word}${r.count === 1 ? '' : 's'}`,
      to: `/content?view=forms&form=${r.formId}&tab=responses`,
    };
  });
  const mailed = list.filter((r) => r.emailed).map((r) => r.name);
  const note =
    mailed.length === list.length
      ? 'Also emailed to you'
      : mailed.length
        ? `Emailed to you: ${mailed.join(', ')}`
        : 'Not emailed to you. Turn it on in each form.';
  return {
    head: `${total} new form ${total === 1 ? 'response' : 'responses'} ${period}`,
    links,
    note,
  };
}
